import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import PageTitle from 'components/PageTitle';
import Button from 'components/Button';

import { URLS } from 'config';

import './styles.scss';

const getImage = (image) => {
  // eslint-disable-next-line
  const img = require(`pages/CarType/images/${image.toLowerCase()}.jpg`);
  return img;
};

const Error = ({ carType, close }) => (
  <div className="mounthly-error">
    <button className="error-close" onClick={close}>
      <i className="material-icons">close</i>
    </button>
    <PageTitle>
      {'Unfortunately, you can\'t be approved now. However, if you able to down payment, you can come back and try again.'}
    </PageTitle>

    <div className="error-wrapper">
      <div className="error-image" style={{ backgroundImage: `url(${carType ? getImage(carType) : ''})` }} />
      <i className="material-icons">clear</i>
    </div>

    <p className="error-info">
      In Part Three, I promised we would get into the resources.
      Before we do, however, let’s discuss a treasure that most of us have
      been exposed to, but don’t take nearly enough time out of our day to
      focus on – the power of prayer.
    </p>
    <Button isLink pathTo={URLS.BASE}>
		Return to home
    </Button>
  </div>
);

Error.propTypes = {
  carType: PropTypes.oneOfType([PropTypes.string, PropTypes.string]).isRequired,
  close: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  carType: state.carType.carType
});


export default connect(mapStateToProps, null)(Error);



// WEBPACK FOOTER //
// ./src/pages/Mounthly/components/Error/index.js